"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BillingAddressContent = void 0;
var _checkoutDelivery = require("@ori/checkout-delivery");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _react = require("react");
var _models = require("../../models");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(e) {
  if ("function" != typeof WeakMap) return null;
  var r = new WeakMap(),
    t = new WeakMap();
  return (_getRequireWildcardCache = function (e) {
    return e ? t : r;
  })(e);
}
function _interopRequireWildcard(e, r) {
  if (!r && e && e.__esModule) return e;
  if (null === e || "object" != typeof e && "function" != typeof e) return {
    default: e
  };
  var t = _getRequireWildcardCache(r);
  if (t && t.has(e)) return t.get(e);
  var n = {
      __proto__: null
    },
    a = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) {
    var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
    i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
  }
  return n.default = e, t && t.set(e, n), n;
}
const DeliveryAddressForm = /*#__PURE__*/(0, _react.lazy)(async () => ({
  default: (await Promise.resolve().then(() => _interopRequireWildcard(require('@ori/address-form')))).DeliveryAddressForm
}));
const BillingAddressContent = ({
  addressFormProps,
  billingAddress,
  shoppingBagOwnerName,
  addressFormat
}) => {
  const {
    getTestIdProps
  } = (0, _testidGenerator.default)();
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [shoppingBagOwnerName ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.Name, {
      ...getTestIdProps(_models.TestId.BillingAddressName),
      children: shoppingBagOwnerName
    }) : null, billingAddress ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_checkoutDelivery.Address, {
      ...billingAddress,
      addressFormat: addressFormat
    }) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.AddressFormWrapper, {
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(DeliveryAddressForm, {
        ...addressFormProps
      })
    })]
  });
};
exports.BillingAddressContent = BillingAddressContent;